import { isRelationalReport, isSingleObjectReport } from 'reporting-data/tsTypes/reportTypes';
import { SnowflakeConditionalFormattingMinAndMax } from './snowflake-conditional-formatting-components/SnowflakeConditionalFormattingMinAndMax';
import { ConfigConditionalFormattingMinAndMax } from './config-conditional-formatting-components/ConfigConditionalFormattingMinAndMax';
import { jsx as _jsx } from "react/jsx-runtime";
const ConditionalFormattingMinAndMax = ({
  report,
  reportDeps,
  onChange,
  selectedColumnName,
  tracker
}) => {
  if (isRelationalReport(report) && selectedColumnName && reportDeps) {
    return /*#__PURE__*/_jsx(SnowflakeConditionalFormattingMinAndMax, {
      report: report,
      reportDeps: reportDeps,
      onChange: onChange,
      selectedColumnName: selectedColumnName,
      tracker: tracker
    });
  }
  if (isSingleObjectReport(report) && selectedColumnName) {
    return /*#__PURE__*/_jsx(ConfigConditionalFormattingMinAndMax, {
      report: report,
      onChange: onChange,
      selectedColumnName: selectedColumnName,
      tracker: tracker
    });
  }
  return null;
};
export default ConditionalFormattingMinAndMax;